var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
var StyledFormRow = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  margin-bottom: ", "px;\n"], ["\n  box-sizing: border-box;\n  margin-bottom: ", "px;\n"])), function (props) { return props.theme.spacing * 3; });
export default (function (props) {
    return _jsx(StyledFormRow, { children: props.children });
});
var templateObject_1;
//# sourceMappingURL=index.js.map